module.exports = __webpack_public_path__ + "static/img/绞车道人数统计.5541d906.png";